import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './Toast.css';
import './ToastContainer.css';

const Toast = ({message, type = 'error', onClose, duration = 5000}) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return ReactDOM.createPortal(
    <div className="toast-container">
      <div className={`toast toast-${type}`}>
        <div className="toast-content">
          <span className="toast-icon">
            {type === 'error' ? '⚠️' : type === 'success' ? '✓' : type === 'warning' ? '⚠' : 'ℹ️'}
          </span>
          <span className="toast-message">{message}</span>
        </div>
        <button className="toast-close" onClick={onClose} type="button">
          {'×'}
        </button>
      </div>
    </div>,
    document.body
  );
};

Toast.propTypes = {
  duration: PropTypes.number,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['error', 'success', 'info', 'warning']),
};

export default Toast;
